.background {
    background-image: url('/sm_mountainBkgrd.jpg');
    background-size: cover;
    background-repeat: no-repeat;
}

.pageHeaderContent {
    margin: auto;
    max-width: 1300px;
    padding: 20px;
}

.pageDashboardTabs {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: auto;
    padding: 20px;
}

.pageBodyNoPadding,
.pageBodyWithPadding {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: auto;
    max-width: 1300px;
}

.pageBodyWithPadding {
    padding: 20px;
}

.titleAndButtons {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
}

.buttons {
    display: flex;
    gap: 25px;
}